let language = {
  SETTING_DEFAULT_SHIPPING_PAGE_TITLE: '默认配送方式',
  SETTING_DEFAULT_SHIPPING_PAGE_DESC: '为您的商店设置默认配送方式，无需为每一笔客户订单手动选择。',
  SETTING_DEFAULT_SHIPPING_RADIO_DISABLE: '关闭',
  SETTING_DEFAULT_SHIPPING_RADIO_ENABLE: '开启（请选择三种配送方式。如果首选配送方式不支持客户所在地区，系统将使用下一可用的配送方式）',
  SETTING_DEFAULT_SHIPPING_PRIMARY_LABEL: '首选方式：',
  SETTING_DEFAULT_SHIPPING_SECONDARY_LABEL: '次选方式：',
  SETTING_DEFAULT_SHIPPING_THIRD_LABEL: '第三方式：',
  SETTING_DEFAULT_SHIPPING_SELECT_ONE_REQUIRED: '请选择至少一个配送方式。',
  SETTING_DEFAULT_SHIPPING_CLEAR_SELECTION: '清空选择',
  SETTING_DEFAULT_SHIPPING_SAVE_BUTTON: '保存',

  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_TITLE: '保存失败',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT: '保存失败，请稍后重试！',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000147: '传入的店铺默认配送方式列表为空。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000159: '没有传入 enable 字段。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000148: '接口没有传入请求体对象。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000149: '店铺 ID 为空。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000150: '店铺 ID 不合法。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000160: 'enable 字段为空。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000141: 'sort 排序优先级未填写。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000151: '默认配送方式 code 不正确。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000152: '默认配送方式 code 重复。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000153: 'sort 排序优先级重复。',
  SETTING_DEFAULT_SHIPPING_SAVE_ERROR_CONTENT_108000154: '该店铺 ID 的配置已存在。',
};

export { language };
